/**
 * MSAL-configuratie voor "Inloggen met Microsoft" (Authorization Code + PKCE, SPA).
 *
 * De authority staat bewust op het /organizations-endpoint, niet op een tenant-vaste
 * URL: zo mogen alleen werk-/schoolaccounts (Entra ID) inloggen en worden privé-
 * Microsoft-accounts meteen bij de voordeur geweigerd. De CLIENT_ID komt uit een
 * Vite-env-var (VITE_OIDC_CLIENT_ID), bij de build ingebakken; lokaal valt hij
 * terug op de dev-registratie.
 * De redirect-URL vangen we automatisch af met window.location.origin (lokaal
 * http://localhost:5173, in productie de prod-URL). Zo staat er geen prod-config hardcoded.
 */
// Client-id uit Vite-env (VITE_OIDC_CLIENT_ID), ingebakken bij de build.
// Fallback = de dev-registratie, zodat lokaal draaien zonder .env blijft werken.
const CLIENT_ID = import.meta.env.VITE_OIDC_CLIENT_ID || '05644bf0-9421-408a-ab06-27544800fb67';

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: 'https://login.microsoftonline.com/organizations',
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// Scopes voor de basale "wie ben ik"-profiel-lees (hoort bij de login zelf).
export const loginRequest = {
  scopes: ['User.Read'],
};
